module.exports = __webpack_public_path__ + "img/img-acbd5c4e.2418a928.png";